import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateMetadata, updateMetadataSelectOptionsWithItemRetailAdjustments } from '../actions';
import { getItemAdjustments } from '../selectors/items';
import MetadataAdjustment from './shop/MetaData/MetadataAdjustment';
import { createAddItemRetailAdjustment, createUpdate } from '../actions';
import * as actions from '../actions/item';
import { createErrorPopup, closePopup } from '../actions/popup';
import { DraggableItemContainer } from './DraggableItem';
import { HandleIcon } from "@commonsku/styles";

import { BASE_ZINDEX } from '../popup-factory';

const updateItemRetailAdjustment = createUpdate('item-retail-adjustment', {
  request: actions.UPDATE_ITEM_RETAIL_ADJUSTMENT_REQUEST,
  success: actions.UPDATE_ITEM_RETAIL_ADJUSTMENT_SUCCESS,
  failure: actions.UPDATE_ITEM_RETAIL_ADJUSTMENT_FAILURE,
  failure_message: 'Unable to update retail adjustment'
});

class MetadataListPopup extends Component {

  constructor(props) {
    super(props);

    this.state = {
        metadata: props.metadata
    };

    this.handleChangeMetadata = this.handleChangeMetadata.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ metadata: nextProps.metadata });
  }

  handleChangeMetadata(field, value, option_index, to_delete) {
    let new_value = value;
    const old_value = this.state.metadata.value;

    if(field === 'value' && this.state.metadata.type === 'SELECT') {
      let options = this.state.metadata.value ? JSON.parse(this.state.metadata.value) : [];
      if(typeof option_index !== 'undefined' && typeof options[option_index] !== 'undefined') {
        if(to_delete) {
          options.splice(option_index, 1);
        }else{
          options[option_index] = value;
        }
      }else{
        options.push(value);
      }
      new_value = JSON.stringify(options);
    }

    if (to_delete || option_index == null) {
      this.setState({
        metadata: Object.assign({}, this.state.metadata, { [field]: new_value })
      }, function() {
        if(to_delete) {
          const item_retail_adjustment_id = this.props.adjustments
            .filter(a => a.parent_id === this.props.metadata_id)
            .find(a => a.option === value)?.item_retail_adjustment_id;
          if (item_retail_adjustment_id) {
            this.props.onUpdateMetadataSelectOptionsWithItemRetailAdjustments(this.props.metadata_id, 'item_retail_adjustments', old_value)
              ({ metadata_value: this.state.metadata.value, id: item_retail_adjustment_id });
          } else {
            this.props.onUpdateMetadataList(this.props.metadata_id, 'value', old_value)(this.state.metadata.value);
          }
        } else {
          this.props.onUpdateMetadataList(this.props.metadata_id, 'value', old_value)(this.state.metadata.value);
        }
      });
    }
  }

  onMove = (dragIndex, hoverIndex) => {
    let options = this.state.metadata.value ? JSON.parse(this.state.metadata.value) : [];
    const dragOption = options[dragIndex];
    if (typeof dragOption !== 'undefined') {
      options.splice(dragIndex, 1);
      options.splice(hoverIndex, 0, dragOption);
      const newValue = JSON.stringify(options);

      this.setState({
        metadata: Object.assign({}, this.state.metadata, { value: newValue })
      });
    }
  };

  onDrop = (item) => {
    this.props.onUpdateMetadataList(this.props.metadata_id, 'value', item.item)(this.state.metadata.value);
  };

  render() {
    const { onUpdateMetadataList, index, onClosePopup, metadata_id, parent_id, parent_type, adjustments, onUpdateMetadataSelectOptionsWithItemRetailAdjustments, onAddRetailAdjustment, onUpdateRetailAdjustment, showError } = this.props;
    const { metadata } = this.state;

    return (
      <div className="reveal large" style={{ display: 'block', zIndex: BASE_ZINDEX + index, height: 'initial', overflow: 'auto', maxHeight: '100%' }} data-test-id='question-options'>
        <div className="row small-12 columns">
          <h3>Question Options</h3>
          <a className="button" style={{ position: 'absolute', right: '1rem', top: '1rem' }} onClick={e => {e.preventDefault(); onClosePopup();}}>Done</a>
        </div>
        <div className="row small-12 columns">
          <table>
            <thead>
              <tr>
                <td></td>
                <td>Options</td>
                {parent_type === "ITEM" && <td>Upcharge ($)</td>}
                <td>Actions</td>
              </tr>
            </thead>
            <tbody>
              {JSON.parse(metadata.value || '[]').map((o, i) => {
                const adjustment = adjustments.find(a => a.option === o);
                return (
                  <DraggableItemContainer
                    key={'metadata-value-' + i}
                    index={i}
                    onDrop={this.onDrop}
                    onMove={this.onMove}
                    item={o}
                    canDrag={Boolean(o)}
                    type="Item"
                  >
                    <tr>
                      <td className="align-self-center">{o ? <HandleIcon color="#DAE9EE" altText={o || ''} /> : ''}</td>
                      <td style={{ paddingTop: 0 }}>
                        <input type="text" placeholder="Option" defaultValue={o} style={{ minWidth: '100px', margin: 0 }}
                          onFocus={e => e.target.select()}
                          onChange={e => this.handleChangeMetadata('value', e.target.value.trim() === '' ? '' : e.target.value, i)}
                          onBlur={e => {
                            const options = metadata.value ? JSON.parse(metadata.value) : [];
                            const trimmedValue = e.target.value.trim();
                            if (typeof options[i] === 'undefined' || options[i] === trimmedValue) {
                              return;
                            }

                            if (trimmedValue !== '' && options.includes(trimmedValue)) {
                              showError('Option value must be unique. Duplicate values are not allowed here.');
                              return;
                            }

                            options[i] = trimmedValue;
                            const new_value = JSON.stringify(options);
                            if (adjustment?.item_retail_adjustment_id) {
                              onUpdateMetadataSelectOptionsWithItemRetailAdjustments(metadata_id, 'item_retail_adjustments', o)
                                ({ metadata_value: new_value, id: adjustment.item_retail_adjustment_id, option: trimmedValue });
                            } else {
                              onUpdateMetadataList(metadata_id, 'value', o)(new_value);
                            }
                          }}
                        />
                      </td>
                      {parent_type === "ITEM" && (
                        <td style={{ paddingTop: 0 }}>
                          <MetadataAdjustment
                            option={o}
                            metadataId={metadata_id}
                            adjustment={adjustment?.adjustment}
                            parentId={parent_id}
                            itemRetailAdjustmentId={adjustment?.item_retail_adjustment_id}
                            onUpdateRetailAdjustment={onUpdateRetailAdjustment}
                            onAddRetailAdjustment={onAddRetailAdjustment}
                          />
                        </td>
                      )}
                      <td>
                        <a onClick={e => {e.preventDefault(); this.handleChangeMetadata('value', o, i, true);}}>delete</a>
                      </td>
                    </tr>
                  </DraggableItemContainer>
                );
              })}
              <tr><td><a onClick={e => {e.preventDefault(); this.handleChangeMetadata('value', '');}}>+ add option</a></td></tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const metadata = ownProps.parent_type === 'ITEM' ? state.entities.items[ownProps.parent_id].metadata.find(m => m.metadata_id === ownProps.metadata_id)
    : state.entities.shops[ownProps.parent_id].metadata_list.find(m => m.metadata_id === ownProps.metadata_id);
  const adjustments = ownProps.parent_type === 'ITEM' ? getItemAdjustments(state, { item_id: ownProps.parent_id }) : [];

  return {
    metadata,
    adjustments: adjustments.filter(a => a.parent_type === "METADATA" && a.parent_id === ownProps.metadata_id)
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClosePopup: () => dispatch(closePopup()),
  onUpdateMetadataList: (metadata_id, field, previous_value) => value => {
    dispatch(updateMetadata(ownProps.parent_id, metadata_id, field, previous_value, value, ownProps.parent_type));
  },
  onUpdateMetadataSelectOptionsWithItemRetailAdjustments: (metadata_id, field, previous_value) => value => {
    dispatch(updateMetadataSelectOptionsWithItemRetailAdjustments(ownProps.parent_id, metadata_id, field, previous_value, value, ownProps.parent_type));
  },
  onAddRetailAdjustment: (item_id, selector, value) => {
    dispatch(createAddItemRetailAdjustment(item_id, selector, value));
  },
  onUpdateRetailAdjustment: (item_retail_adjustment_id, selector, prevValue, value) => {
    dispatch(updateItemRetailAdjustment(item_retail_adjustment_id, selector, prevValue, value));
  },
  showError: (message) => {
    dispatch(createErrorPopup(message));
  }
});

const ConnectedMetadataListPopup = connect(mapStateToProps, mapDispatchToProps)(MetadataListPopup);
export default ConnectedMetadataListPopup;
